import { styled, css } from "styled-components";

import { colorCSS, minWidth, maxWidth } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

type InputEmailProps = {
    $bxpProminence: ReturnType<typeof css>;
    $isWidthConstrained?: boolean;
};

export const Form = styled.form<{
    hideEmailInput?: boolean;
}>`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("gap", "1rem")}
    ${redundantCssFromKebab("justify-content", "center")}

    @media ${maxWidth.md} {
        /* BxpButton wrapper */
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Styling for child/nested elements */
        > div {
            ${redundantCssFromKebab("flex-grow", "1")}

            a,
            button {
                ${redundantCssFromKebab("justify-content", "center")}
                ${redundantCssFromKebab("width", "100%")}
            }
        }
    }

    /* BXPT-1430: Remove this after experimentation is completed */
    ${({ hideEmailInput }) =>
        hideEmailInput &&
        `
            + span[class*="ModalTrigger"] {
                display: inline-block;
                margin-block-start: 1rem;
            }
            
            @media ${minWidth.lg} {
                display: inline-flex;

                + span[class*="ModalTrigger"] {
                    margin-inline-start: 1rem;
                    margin-block-start: 0;
                }
            }
        `}

    .xs-text-left & {
        justify-content: start;
    }
    .xs-text-center & {
        justify-content: center;
    }

    @media ${minWidth.sm} {
        .sm-text-left & {
            justify-content: start;
        }
        .sm-text-center & {
            justify-content: center;
        }
    }
    @media ${minWidth.md} {
        flex-wrap: wrap;

        .md-text-left & {
            justify-content: start;
        }
        .md-text-center & {
            justify-content: center;
        }
    }
    @media ${minWidth.lg} {
        .lg-text-left & {
            justify-content: start;
        }
        .lg-text-center & {
            justify-content: center;
        }
    }
    @media ${minWidth.xl} {
        .xl-text-left & {
            justify-content: start;
        }
        .xl-text-center & {
            justify-content: center;
        }
    }
`;

export const InputEmail = styled.input<InputEmailProps>`
    ${redundantCssFromKebab("display", "none")}
    ${({ $bxpProminence }) => $bxpProminence};
    ${redundantCssFromKebab("border", `1px solid ${colorCSS("N40")}`)}
    ${redundantCssFromKebab("border-radius", "0.3rem")}
    max-width: ${(props: InputEmailProps) =>
        props.$isWidthConstrained ? 300 : 376}px;
    ${redundantCssFromKebab("padding-left", "0.75rem")}
    ${redundantCssFromKebab("padding-right", "0.75rem")}
    ${redundantCssFromKebab("transition", "250ms ease-out")}
    ${redundantCssFromKebab("width", "376px")}

    &::placeholder {
        ${redundantCssFromKebab("color", `${colorCSS("N80")}`)}
        ${redundantCssFromKebab("opacity", "1")}
    }

    @media ${minWidth.md} {
        ${redundantCssFromKebab("display", "block")}
    }
`;
